import ZigZag_70s from "../../assets/images/zig-zag-70s.png";
import ZigZag_70s_2 from "../../assets/images/zig-zag-70s-2.png";

const images = () =>{
    return {ZigZag_70s, ZigZag_70s_2}
}

export default images;